'use client';

import React, { useEffect } from 'react';
import AOS from 'aos';
import 'aos/dist/aos.css';
import styles from './CenteredPictureAndParagraph.module.scss';

interface CenteredPictureAndParagraphProps {
    title?: string;
    imageUrl: string;
    imageTitle: string;
    paragraph: string;
    id?: string;
}

const CenteredPictureAndParagraph: React.FC<CenteredPictureAndParagraphProps> = ({
    title,
    imageUrl,
    imageTitle,
    paragraph,
    id
}) => {
    useEffect(() => {
        AOS.init({ duration: 1000, once: true });
    }, []);

    return (
        <section className={styles.wrapper} id={id}
        >
            <div className={styles.inner}>
                {title && (
                    <h2 className={styles.title} data-aos="fade-up">
                        {title}
                    </h2>
                )}
                <figure className={styles.imageContainer} data-aos="fade-up" data-aos-delay="150">
                    <div className={styles.imageWrapper}>
                        <img
                            src={imageUrl}
                            alt={imageTitle || 'Artwork'}
                            className={styles.image}
                            loading="lazy"
                            decoding="async"
                        />
                        <figcaption className={styles.hoverLabel}>{imageTitle || 'Artwork'}</figcaption>
                    </div>
                </figure>
                <p className={styles.paragraph} data-aos="fade-up" data-aos-delay="300">
                    {paragraph}
                </p>
            </div>
        </section>
    );
};

export default CenteredPictureAndParagraph;
